import React from "react";
import { Link } from "react-router-dom";
import { SEOHelmet } from "../components/common/SEOHelmet";

export default function UnknownPage() {
  return (
    <>
      <SEOHelmet page="notFound" noIndex={true} pathname="/404" />
      <main className="grid min-h-[60vh] place-items-center px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center space-y-6">
          <p className="text-5xl font-semibold text-ergo-500">404</p>
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">
            Diese Seite existiert nicht.
          </h1>
          <p className="text-base text-gray-500 dark:text-gray-400">
            Die gewünschte Seite konnte leider nicht gefunden werden.
          </p>
          <div className="mt-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-full
                border border-ergo-500/30 dark:border-ergo-400/30
                bg-ergo-50/60 dark:bg-ergo-900/30
                px-6 py-2.5 text-sm font-medium
                text-ergo-700 dark:text-ergo-300
                hover:bg-ergo-100 dark:hover:bg-ergo-900/50
                hover:border-ergo-500/50 dark:hover:border-ergo-400/50
                transition-all duration-200"
            >
              Zur Startseite
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
